import React from "react";
import styled from "../style.module.css";
import { GREEN, TEAL, COPPER } from "./theme";

const ICON = { subscription: "★", signup_free: "+" };
const COLOR = { subscription: GREEN, signup_free: TEAL };

// Relative time like "2h ago" from an ISO string (no date lib).
const ago = (iso) => {
  const then = new Date(iso).getTime();
  if (!then) return "";
  const s = Math.max(0, Math.floor((Date.now() - then) / 1000));
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
};

const money = (n) =>
  n == null ? null : `$${Number(n).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const ActivityFeed = ({ title = "Recent Activity", items, emptyHint }) => (
  <div className={styled.chartCard}>
    <div className={styled.chartCardHead}>
      <h3 className={styled.chartTitle}>{title}</h3>
      <span className={styled.asOfTag}>live</span>
    </div>
    {items && items.length > 0 ? (
      <div className={styled.activityList}>
        {items.map((a, i) => (
          <div key={i} className={styled.activityRow}>
            <span className={styled.activityIcon} style={{ background: (COLOR[a.type] || COPPER) + "22", color: COLOR[a.type] || COPPER }}>
              {ICON[a.type] || "•"}
            </span>
            <span className={styled.activityLabel}>{a.label}</span>
            {a.amount != null && <span className={styled.activityAmount}>{money(a.amount)}</span>}
            <span className={styled.activityTime}>{ago(a.at)}</span>
          </div>
        ))}
      </div>
    ) : (
      <p className={styled.emptyHint}>{emptyHint || "No recent activity."}</p>
    )}
  </div>
);

export default ActivityFeed;
